// Merkezi rol & departman etiketleri / yardımcıları.
// Yeni personel rolleri burada tanımlı; mevcut roller korunur.

export const ROLE_LABELS = {
  // Yönetim / sistem rolleri
  super_admin: 'Süper Admin',
  admin: 'Admin',
  supervisor: 'Süpervizör',
  team_leader: 'Ekip Lideri',
  operator: 'Operatör',
  // Saha
  paramedic: 'Paramedik',
  surucu: 'Sürücü',
  saha_personeli: 'Saha Personeli',
  // İdari
  muhasebe: 'Muhasebe',
  ik: 'İK',
  lojistik: 'Lojistik',
  kurumsal_pazarlama: 'Kurumsal Pazarlama',
  destek_personeli: 'Destek Personeli',
  // Dış / mobil
  external_institution: 'Dış Kurum',
  external_parent_institution: 'Çatı Kurum',
  external_presidency: '112 Başkanlıkları Dış Kullanıcı',
  external_hospital: '112 Hastane Dış Kullanıcı',
  mobile_user: 'Mobil Kullanıcı',
};

// Departmana göre seçilebilir personel rolleri (kullanıcı oluşturma ekranı için)
export const SAHA_ROLES = ['paramedic', 'surucu', 'saha_personeli'];
export const IDARI_ROLES = ['muhasebe', 'ik', 'lojistik', 'kurumsal_pazarlama', 'destek_personeli'];

// Yalnızca kendi yoklama/puantaj ekranlarını gören saha personeli rolleri
export const FIELD_STAFF_ROLES = ['paramedic', 'surucu', 'saha_personeli'];
export const ADMIN_STAFF_ROLES = IDARI_ROLES;
export const PERSONNEL_ROLES = [...SAHA_ROLES, ...IDARI_ROLES];

export const DEPARTMENT_LABELS = {
  saha: 'Saha',
  idari: 'İdari',
};

export const roleTr = (role) => ROLE_LABELS[role] || role || '';
export const departmentTr = (dep) => DEPARTMENT_LABELS[dep] || dep || '';

export const rolesForDepartment = (department) =>
  department === 'saha' ? SAHA_ROLES : department === 'idari' ? IDARI_ROLES : PERSONNEL_ROLES;
